export default __webpack_public_path__ + "static/media/no-result-inbox-radar.c5ae8a22.svg";